import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';

import { ConfiguracoesProjeto, GenericHttpService, MunicipioService, NbpInfoComponent, ParametrosService, UtilHelper } from '../../../shared';
import { ConsumidorModel, ConsumidorService } from './';
import { LoadingService } from '../../../shared-layout/loading/loading.service';

import { Meta } from '@angular/platform-browser';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DadosAcessoConsumidor } from './dados-acesso-consumidor';
import { CidadaoLgpd } from '../consumidor-lgpd/cidadao-lgpd';
import { StorageManagementPortal } from './storage-management-portal';

@Injectable()
export class LoginService {
  private _urlToken: string;
  private _urlTokengovbr: string;
  private unsubConsumidor: Subscription;
  private configuracao: ConfiguracoesProjeto;

  public loginAutorized: Subject<{ logado: boolean; mensagem: string }> = new Subject<{ logado: boolean; mensagem: string }>();

  constructor(
    private readonly http: Http,
    private readonly consumidorService: ConsumidorService,
    private readonly municipioService: MunicipioService,
    private readonly parametrosService: ParametrosService,
    private readonly genericHttpService: GenericHttpService<any>,
    private readonly router: Router,
    private readonly loadingService: LoadingService,
    private meta: Meta,
    private readonly ngbModalService: NgbModal,
  ) {}

  get urlToken() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlToken = this.configuracao.uri + 'autenticacao/login';    
    return this._urlToken;
  }

  get urlTokenGovBr() {
    this.configuracao = this.parametrosService.getConfiguracao();
    this._urlTokengovbr = this.configuracao.uri + 'autenticacao/logingovbr';    
    return this._urlTokengovbr;
  }

  login(consumidorModel: ConsumidorModel): void {

    const dadosAcesso = new DadosAcessoConsumidor();
    dadosAcesso.UserName = btoa(consumidorModel.cpf);
    dadosAcesso.Password = btoa(consumidorModel.senha);
    dadosAcesso.Token = null;

    this.loadingService.exibirLoading('Aguarde, estamos conferindo suas credenciais.');

    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('npb', 'true');
    
    this.http.post(this.urlToken, dadosAcesso, { headers: headers }).subscribe(
      (data: any) => {
        
        const bearerToken = this.obterTokenTratado(data._body);
        localStorage.setItem('authorizationData', bearerToken);

        this.genericHttpService.setApiKey(bearerToken);

        this.unsubConsumidor = this.consumidorService.getConsumidorPeloCPF(+consumidorModel.cpf).subscribe(consumidor => {

          consumidor.stsParticipaSorteio = consumidor.statusParticipanteSorteio;

          this.consumidorService.setConsumidorModel(consumidor);

          if(CidadaoLgpd.TermoLgpdAceito()) {
             this.municipioService.getMunicipiosIBGE(consumidor.codigoMunicipioIBGE);
          }
          
          localStorage.setItem('consumidor', JSON.stringify(consumidor));

          // Variáveis da ferramenta de monitoramento
          this.DefinirVariaveisDynatrace();

          this.loadingService.esconderLoading();
          this.loginAutorized.next({
            logado: true,
            mensagem: 'Sucesso'
          });

          this.unsubConsumidor.unsubscribe();

          if(CidadaoLgpd.TermoLgpdAceito()) {
            this.verificaInstituicoes(consumidor);
          }
        
        },erro => {

          let err = erro as StatusRequisicao;

          this.loginAutorized.next({
            logado: false,
            mensagem: erro.motivo        
          });
          this.loadingService.esconderLoading();
        },    
               
      );
    },
      error => {

        let content = this.obterErroTratado(error._body);
        let err = content as StatusRequisicao;
        
        this.loginAutorized.next({
          logado: false,
          mensagem: err.motivo        
        });
        this.loadingService.esconderLoading();
      },
      () => {
        this.loadingService.esconderLoading();
      }
    );
  }

  loginToken(consumidorModel: ConsumidorModel): void {

    const dadosAcesso = new DadosAcessoConsumidor();
    dadosAcesso.UserName = btoa(consumidorModel.cpf);
    dadosAcesso.Password = null;
    dadosAcesso.Token = consumidorModel.token;

    this.loadingService.exibirLoading('Aguarde, estamos conferindo suas credenciais.');

    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('npb', 'true');
    
    this.http.post(this.urlTokenGovBr, dadosAcesso, { headers: headers }).subscribe(
      (data: any) => {
        
        const bearerToken = this.obterTokenTratado(data._body);
        localStorage.setItem('authorizationData', bearerToken);

        this.genericHttpService.setApiKey(bearerToken);

        this.unsubConsumidor = this.consumidorService.getConsumidorPeloCPF(+consumidorModel.cpf).subscribe(consumidor => {

          consumidor.stsParticipaSorteio = consumidor.statusParticipanteSorteio;

          this.consumidorService.setConsumidorModel(consumidor);

          if(CidadaoLgpd.TermoLgpdAceito()) {
             this.municipioService.getMunicipiosIBGE(consumidor.codigoMunicipioIBGE);
          }
          
          localStorage.setItem('consumidor', JSON.stringify(consumidor));

          // Variáveis da ferramenta de monitoramento
          this.DefinirVariaveisDynatrace();

          this.loadingService.esconderLoading();
          this.loginAutorized.next({
            logado: true,
            mensagem: 'Sucesso'
          });

           localStorage.setItem('login_via_gov_br', "1");

          this.unsubConsumidor.unsubscribe();

          if(CidadaoLgpd.TermoLgpdAceito()) {
            this.verificaInstituicoes(consumidor);
          }

        },erro => {

          let err = erro as StatusRequisicao;

          this.loginAutorized.next({
            logado: false,
            mensagem: erro.motivo        
          });
          this.loadingService.esconderLoading();
        },    
               
      );
    },
      error => {

        let content = this.obterErroTratado(error._body);
        let err = content as StatusRequisicao;
        
        this.loginAutorized.next({
          logado: false,
          mensagem: err.motivo        
        });
        this.loadingService.esconderLoading();
      },
      () => {
        this.loadingService.esconderLoading();
      }
    );
  }

   // Variáveis a serem utilizadas pela ferramenta de monitoramento
  private DefinirVariaveisDynatrace() {
       
    try{
     
       let ConsumidorId = JSON.parse(localStorage.getItem('consumidor'))['consumidorId'];

        // Localstorage
        localStorage.setItem('ConsumidorID', ConsumidorId);

        // MetaTag
        this.meta.addTag({ name: 'ConsumidorID', content: ConsumidorId });
        
        // Cookie
        // Foi colocado essa simples instrução em Javacript para não ter que adicionar ao projeto nenhum componente adicional
        // Se for necessário no futuro um trabalho de maior complexidade com cookies, avaliar a adição do pacote e não trabalhar 
        // com JavaScript nativo
        document.cookie = "ConsumidorID=" + ConsumidorId;
  
    }catch(e){
      // Em caso de erro, o mesmo deve ser minimamente tratado para impedir que afete a aplicação
      // Na refatoração do tratamento de exceção passar a seguir novo padrão
      console.log('Dynatrace: ' + e); 
    }
  }

  private obterTokenTratado(dadosCompletosToken: string) {
    return JSON.parse(dadosCompletosToken);
  }

  private obterErroTratado(dadosErro: string) {
    return JSON.parse(dadosErro);
  }

  private obterRespostaErroLoginTratado(bodyErro: string) {
    let json = JSON.parse(bodyErro);
    return json["error_description"];
  }

  public logout() {

    new StorageManagementPortal(this.parametrosService).Logout();
    this.consumidorService.mn0030 = '';
  }

  public isLogged(): boolean {
    const consumidor = localStorage.getItem('consumidor');
    localStorage.getItem('authorizationData');
    const editMode = sessionStorage.getItem('editMode');
    if (consumidor && editMode) {
      return true;
    }

    return false;
  }

  get urlBaseInstituicao() {
    this.configuracao = this.parametrosService.getConfiguracao();
    const _urlBase = this.configuracao.uri + 'Instituicao';

    return _urlBase;
  }

  get urlBaseInstituicaoCidadao() {
    this.configuracao = this.parametrosService.getConfiguracao();
    const _urlBase = this.configuracao.uri + 'instituicao-cidadao';

    return _urlBase;
  }

  public verificaInstituicoes(consumidor: ConsumidorModel, redirect: boolean = true) {
    var id = '';

    if (consumidor !== null && consumidor.consumidorId != null) {
      id = `${UtilHelper.lpad(consumidor.cpfBase.toString(), 9)}${UtilHelper.lpad(
        consumidor.cpfDigito.toString(),
        2
      )}`;
    }

    this.genericHttpService.getById(this.urlBaseInstituicaoCidadao + `/listagem/instituicoes/${id}`).subscribe(
      data => {
        if (data && data.length == 0) {
          const confirmModal = this.ngbModalService.open(NbpInfoComponent, { size: 'lg' });
          confirmModal.componentInstance.info = 'Neste momento, não há indicação de instituição em seu cadastro. Para compartilhar seus documentos fiscais é preciso indicar pelo menos uma instituição da Campanha Sua Nota é um Show de Solidariedade (área social ou saúde).';
        }
      },
      error => {

        // Apresenta a mensagem de erro para o usuário.
        let erro = error as StatusRequisicao;
        console.log(erro.motivo);
      }
    );
  }

  public getCpfUsuarioLogado(): string {
    if (!this.isLogged()) {
      return null;
    }

    const consumidor = JSON.parse(localStorage.getItem('consumidor'));
    const cpfConcatenado = `${UtilHelper.lpad(consumidor.cpfBase, 9)}${UtilHelper.lpad(consumidor.cpfDigito, 2)}`;

    return cpfConcatenado;
  }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/login.service.ts